import React, { useEffect, useState } from "react";
import { ArrowUpRight, Camera } from "lucide-react";
import { api } from "@/lib/api";

export default function KitchenTour() {
  const [shots, setShots] = useState([]);

  useEffect(() => {
    api
      .get("/kitchen-tour")
      .then((r) => setShots(r.data))
      .catch(() => setShots([]));
  }, []);

  if (shots.length === 0) return null;

  return (
    <section
      className="py-16 lg:py-24 border-t border-[var(--border)] overflow-hidden"
      data-testid="kitchen-tour-section"
      id="tour"
    >
      <div className="container-nk">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-9">
          <div>
            <p className="eyebrow flex items-center gap-2 text-gold">
              <Camera size={13} />
              // Inside the Hub
            </p>
            <h2 className="font-display text-[44px] md:text-[60px] leading-[0.95] mt-3">
              The Kitchen Tour
            </h2>
            <p className="text-muted text-[14px] mt-3 max-w-md font-light leading-relaxed">
              Built ground-up for delivery and walk-ins. Twenty kitchens, one
              roof, one obsession with getting every order right.
            </p>
          </div>
          <span className="inline-flex items-center gap-2 font-mono text-[10.5px] uppercase tracking-[0.18em] text-muted">
            Swipe / scroll →
          </span>
        </div>
      </div>

      <div className="tour-rail" data-testid="kitchen-tour-rail">
        <div className="tour-rail-inner">
          {shots.map((s, i) => (
            <article
              key={s.id}
              className="tour-card"
              data-testid={`kitchen-tour-card-${i}`}
            >
              <div className="tour-card-img">
                <img src={s.image} alt={s.label} loading="lazy" />
              </div>
              <div className="tour-card-meta">
                <p className="font-mono text-[9.5px] uppercase tracking-[0.18em] text-gold mb-1">
                  {String(i + 1).padStart(2, "0")} / {String(shots.length).padStart(2, "0")}
                </p>
                <h3 className="font-display text-[24px] leading-tight">{s.label}</h3>
                {s.sub && (
                  <p className="text-[12.5px] text-[var(--text)]/70 mt-1 leading-snug">
                    {s.sub}
                  </p>
                )}
              </div>
              <ArrowUpRight size={16} className="tour-card-icon" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
